// v8
(function () {

  const COLOR_OPTION_INDEX = 0;

  function getGalleryItems() {
    return Array.from(
      document.querySelectorAll(
        '.product__media-item[data-media-type="image"]:not(.swiper-slide-duplicate)'
      )
    );
  }

  function getItemAlt(item) {
    const img = item.querySelector('img');
    return img ? (img.getAttribute('alt') || '').trim() : '';
  }

  function isRollover(alt) {
    return alt.toLowerCase().endsWith('rollover');
  }

  function getColorAlts(items) {
    return [...new Set(items.map(getItemAlt).filter(function(alt) {
      return alt && !isRollover(alt);
    }))];
  }

  function filterImages(selectedColor) {
    const items = getGalleryItems();
    if (!items.length) return;
    const colorAlts = getColorAlts(items);
    const selectedLower = selectedColor.toLowerCase();
    const hasColorTaggedImages = colorAlts.some(function(a) {
      return a.toLowerCase() === selectedLower;
    });
    items.forEach(function(item) {
      const alt = getItemAlt(item);
      const altLower = alt.toLowerCase();
      if (isRollover(alt)) {
        item.style.setProperty('display', 'none', 'important');
        item.setAttribute('aria-hidden', 'true');
        return;
      }
      if (!alt || !hasColorTaggedImages) {
        item.style.removeProperty('display');
        item.removeAttribute('aria-hidden');
        return;
      }
      if (altLower === selectedLower) {
        item.style.removeProperty('display');
        item.removeAttribute('aria-hidden');
      } else {
        item.style.setProperty('display', 'none', 'important');
        item.setAttribute('aria-hidden', 'true');
      }
    });
    requestAnimationFrame(function() {
      window.dispatchEvent(new Event('resize'));
    });
  }

  function showAllNonRollover() {
    getGalleryItems().forEach(function(item) {
      const alt = getItemAlt(item);
      if (isRollover(alt)) {
        item.style.setProperty('display', 'none', 'important');
        item.setAttribute('aria-hidden', 'true');
      } else {
        item.style.removeProperty('display');
        item.removeAttribute('aria-hidden');
      }
    });
  }

  // Only needed for variant swatch clicks — initial load is handled by Liquid
  document.addEventListener('variant:changed', function(evt) {
    const variant = evt.detail && evt.detail.variant;
    if (!variant) { showAllNonRollover(); return; }
    const color = variant.options && variant.options[COLOR_OPTION_INDEX];
    if (!color) { showAllNonRollover(); return; }
    filterImages(color);
  });

})();